'use client';

import type { ReactNode } from 'react';

import { useHeaderMainSection } from './use-header-main-section';

export function HeaderMainSection({ children }: { children: ReactNode }) {
    const containerRef = useHeaderMainSection();

    return (
        <div ref={containerRef} className="header__main-section-container">
            {children}
        </div>
    );
}
